import { getCurrencyConfigForWalletId } from '../../../utils'
import { playerStoreInitialValues, playerStoreKeys } from '../playerStoreConstants'
import { config } from '../../../../components/Init/Init'
import { useSetPlayerStoreData } from '../hooks'
import { usePlayerStore } from '../hooks/usePlayerStore'

export const useSetPlayerActiveCurrencyData = () => {
  const { setPlayerStoreData } = useSetPlayerStoreData()
  const playerStore = usePlayerStore()
  const playerWallets = playerStore.use.playerWallets()

  const setPlayerActiveCurrencyData = walletId => {
    let playerActiveCurrencyData = playerStoreInitialValues[playerStoreKeys.playerActiveCurrencyData]

    if (config.enableSweepstakes && walletId) {
      playerActiveCurrencyData =
        getCurrencyConfigForWalletId(playerWallets, walletId) ||
        playerStoreInitialValues[playerStoreKeys.playerActiveCurrencyData]
    }

    setPlayerStoreData(
      {
        [playerStoreKeys.playerActiveCurrencyData]: playerActiveCurrencyData,
        [playerStoreKeys.activeCurrencyId]: walletId
      },
      'setPlayerActiveCurrencyData'
    )
  }
  return { setPlayerActiveCurrencyData }
}
